// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import * as firebase from "firebase/app";
import { getStorage } from "firebase/storage";
import { startTransition } from "react";
// import "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbcqHRa9q-9IRc56W5TvjnksXNsxCFjAU",
  authDomain: "badge-authenticator.firebaseapp.com",
  projectId: "badge-authenticator",
  storageBucket: "badge-authenticator.appspot.com",
  messagingSenderId: "11707363797",
  appId: "1:11707363797:web:090b3078f06603f0268d5c",
};

const app = initializeApp(firebaseConfig);

const storage = getStorage(app);
// const storageRef = storage.ref();
// const projectFirestore = firebase.firestore();
console.log(storage);
export { storage };
